import axios from "axios";

//GradeService
export default {
	getGClasses() {
		return axios.get(`/v1/gclasses`);
	},

	getGClassesPrefilled() {
		return axios.get(`/v1/gclasses/prefilled`);
	},

	getGClassUsers(gcID) {
		return axios.get(`/v1/gclass/${gcID}/users`);
	},

	importClass(gcID, section) {
		return axios.post(`/v1/gclass/${gcID}/import`, section);
	}
};